var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.8 9h-5.6A1.2 1.2 0 009 10.2v27.6a1.2 1.2 0 001.2 1.2h5.6a1.2 1.2 0 001.2-1.2V10.2A1.2 1.2 0 0015.8 9zm-5.6-3A4.2 4.2 0 006 10.2v27.6a4.2 4.2 0 004.2 4.2h5.6a4.2 4.2 0 004.2-4.2V10.2A4.2 4.2 0 0015.8 6h-5.6zm27.6 3h-5.6a1.2 1.2 0 00-1.2 1.2v27.6a1.2 1.2 0 001.2 1.2h5.6a1.2 1.2 0 001.2-1.2V10.2A1.2 1.2 0 0037.8 9zm-5.6-3a4.2 4.2 0 00-4.2 4.2v27.6a4.2 4.2 0 004.2 4.2h5.6a4.2 4.2 0 004.2-4.2V10.2A4.2 4.2 0 0037.8 6h-5.6z"}));
}

Pause.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Pause;

Pause.default = Pause;
